import { gql } from '@apollo/client';

export const QUERY_HOME_PAGE = gql`
  query HomePage {
    dailyBubblePage {
      data {
        attributes {
          headerSection {
            message
          }

          sections {
            yourDailyBubbleTitle
            trendingThisWeekTitle
            yourWeeklyquestionTitle
            yourWeeklyQuestionDescription
            yourWeeklyQuestionOnboardingTitle
            latestPodcastTitle
            learnTitle
            wildcardTitle
          }

          dailySection {
            insightTitle
            insightDescription
            insightBtnLabel
            mindfulMinuteTitle
            mindfulMinuteDescription
            mindfulMinuteBtnLabel
            emotionWheelTItle
            emotionWheelDescription
            emotionWheelBtnLabel
            dailyQuoteTitle
          }
          onboardingQuestions {
            title
            description
            btnLabel
          }
          finishingCard {
            finishingCardEmotionWheel {
              trackAgain
              yourCalendar
              title
              emotions
              yourStreak
              days
              youHaveTracked
            }
            finishingCardInsight {
              title
              insights
              yourStreak
              days
              readAgain
              youHaveRead
            }
            finishingCardMindfulMinute {
              title
              minutes
              yourStreak
              days
              startAgain
              relatedContent
              youHaveWatched
            }
            finishingCardSurvey {
              title
              youHaveAnswered
              questions
              learnMore
              hideThisCard
            }
          }
        }
      }
    }
  }
`;
